<div class="svgContent" [innerHtml]="getSVGContent()"></div>